import 'promise-polyfill/src/polyfill';

import Vue from 'vue';
import App from './App.vue';
import router from '@/router';
import store from '@/store';
import { MutationType } from '@/enums';
import {loadExternalScriptsFromEnv} from "@/utils/externalJsLoader";

Vue.config.productionTip = false;

// @ts-ignore
window.fillBlank = function() {
	for (let domainKey in store.state.domains) {
		let domain = store.state.domains[domainKey];

		for (let chapterKey in domain.chapters) {
			let chapter = domain.chapters[chapterKey];

			for (let themeKey in chapter.themes) {
				let theme = chapter.themes[themeKey];

				for (let questionKey in theme.questions) {
					let question = theme.questions[questionKey];

					if (questionKey !== '183') {
						store.commit(MutationType.PUSH_NO_PRODUCT_QUESTION, parseInt(questionKey, 10));
					}
				}

				store.commit(MutationType.PUSH_FINISHED_THEME, parseInt(themeKey, 10));
			}
		}
	}

};

console.log('MAIN.TS');


const createApp = () => {
	new Vue({
		router,
		store,
		render: (h) => h(App)
	}).$mount('#app');
};

loadExternalScriptsFromEnv().then(() => {
	createApp();
}).catch(() => {
	createApp();
})
